import { render } from "./EmployeeAnnouncementDetails.vue?vue&type=template&id=d2a86e6e&scoped=true"
import script from "./EmployeeAnnouncementDetails.vue?vue&type=script&lang=js"
export * from "./EmployeeAnnouncementDetails.vue?vue&type=script&lang=js"

import "./EmployeeAnnouncementDetails.vue?vue&type=style&index=0&id=d2a86e6e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2a86e6e"]])

export default __exports__